export function isString(obj) {
	return Object.prototype.toString.call(obj) === '[object String]'
}

export function isObject(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]'
}

export function isArray(obj) {
	return Object.prototype.toString.call(obj) === '[object Array]'
}

/**
 * 数据非空验证
 * @desc 验证数据是否为 null undefined [] {} ''
 * @param data
 * @return {boolean}
 */
export function isEmpty(data) {
	if (data === null) return true
	if (data === undefined) return true
	if (Object.prototype.toString.call(data) === '[object Array]') return data.length === 0
	if (Object.prototype.toString.call(data) === '[object Object]') return Object.keys(data).length === 0
	if (typeof data === 'string') return data.trim() === ''
	return false
}

/**
 * @desc 判断对象属性是否全部为空，是返回true
 * @param data
 * @return {boolean}
 */
export function isEmptyObj(data) {
	if (isEmpty(data)) return true
	if (isObject(data)) {
		for (const key in data) {
			if (Object.hasOwnProperty.call(data, key)) {
				const element = data[key]
				if (isObject(element)) {
					return isEmptyObj(element)
				} else {
					if (!isEmpty(element)) {
						return false
					}
				}
			}
		}
		return true
	}
	return false
}

/**
 * @desc 判断对象属性是否含有空，是返回true
 * @param data
 * @return {boolean}
 */
export function isObjHasEmptyParam(data) {
	if (isEmpty(data)) return true
	if (isObject(data)) {
		for (const key in data) {
			if (Object.hasOwnProperty.call(data, key)) {
				const element = data[key]
				if (isObject(element)) {
					return isObjHasEmptyParam(element)
				} else {
					if (isEmpty(element)) {
						return true
					}
				}
			}
		}
		return false
	}
	return false
}

/**
 * @desc 判断是否为JSON对象，是返回true
 * @param data
 * @return {boolean}
 */
export function isJson(str) {
	if (isEmpty(str)) return false
	if (typeof str !== 'string') return false

	try {
		if (typeof JSON.parse(str) === 'object') {
			return true
		}
	} catch (error) {
		return false
	}
	
	return false
}



// WEBPACK FOOTER //
// ./src/utils/types.js